import React from "react";
import { PhoneCall, Clock } from "lucide-react";
import { sla } from "@/lib/sla";

/**
 * LiveResponseBadge — honest availability badge.
 *
 * Previously showed pseudo-live numbers ("~4 min", "3 tecnici in zona")
 * generated client-side. Those were not measurements and undermined trust
 * once noticed. The badge now states verifiable commitments only, sourced
 * from `lib/sla.js` so they are consistent across the whole site.
 */
export function LiveResponseBadge({ lang = "it", className = "", testId = "live-response-badge" }) {
  const isIt = lang !== "en";
  return (
    <div
      className={`rounded-2xl border border-[hsl(var(--success))]/30 bg-[hsl(var(--success))]/8 px-4 py-3 ${className}`}
      data-testid={testId}
      role="status"
    >
      <div className="flex items-center gap-2">
        <span className="relative inline-flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full rounded-full bg-[hsl(var(--success))] opacity-75 animate-ping" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[hsl(var(--success))]" />
        </span>
        <span className="text-[12px] font-bold uppercase tracking-wider text-[hsl(var(--success))]">
          {isIt ? "Reperibilità H24 attiva" : "24/7 availability active"}
        </span>
      </div>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 text-sm">
        <div className="flex items-start gap-2">
          <PhoneCall className="h-4 w-4 mt-0.5 shrink-0 text-[hsl(var(--brand-aqua))]" aria-hidden="true" />
          <div>
            <span className="block text-[12px] text-[hsl(var(--muted-foreground))]">{isIt ? "Risposta al telefono" : "Phone answer"}</span>
            <span className="block font-semibold text-[hsl(var(--brand-navy))]" data-testid="live-response-phone">{isIt ? "Il titolare, H24" : "The owner, 24/7"}</span>
          </div>
        </div>
        <div className="flex items-start gap-2">
          <Clock className="h-4 w-4 mt-0.5 shrink-0 text-[hsl(var(--brand-aqua))]" aria-hidden="true" />
          <div>
            <span className="block text-[12px] text-[hsl(var(--muted-foreground))]">{isIt ? "Arrivo sul posto" : "On-site arrival"}</span>
            <span className="block font-semibold text-[hsl(var(--brand-navy))]" data-testid="live-response-arrival">{sla("arrivalShort", lang)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveResponseBadge;
